import request from '../../../request';

export default {
  actions: {
    getUsers(_, companyId) {
      return request.get('users', {
        params: {
          company_id: companyId,
        }
      });
    },

    changeUserPassword(_, payload) {
      return request.put('users/change-password/' + payload.id, payload);
    },

    createUser(_, payload) {
      return request.post('users', payload);
    },

    updateUser(_, payload) {
      return request.put('users/' + payload.id, payload);
    },

    deleteUser(_, id) {
      return request.delete('users/' + id);
    },
  }
}
